module.exports = __webpack_public_path__ + "media/images/svg/logos_footer_m-e405cc47c71c158256036d1d2c80225a.svg";